export const OAuthSettings = {
  appClientId: '5d58edb8-f9a0-468a-adf5-518eecd1064a',
  appTenantId: '5888eb58-c3f1-47aa-aaea-6423329e6271',
  authority: 'https://login.microsoftonline.com/5888eb58-c3f1-47aa-aaea-6423329e6271',
  redirectUri: '/',
  scopesGrapheMs: ['user.read', 'mail.read'],
  scopesBc: ['https://api.businesscentral.dynamics.com/.default']
}